import { ReactNode, useState } from "react";
import { useFormContext } from "react-hook-form";
import Eye from "@/assets/icons/Eye.svg";
import EyeCross from "@/assets/icons/EyeCross.svg";

export type InputFieldProps = {
  icon?: ReactNode;
  name: string;
  label: string;
  placeholder?: string;
  type?: "text" | "email" | "password";
  spacing?: boolean;
  className?: string;
};

const HookFormInputField = ({
  icon,
  name,
  label,
  placeholder,
  type = "text",
  className,
}: InputFieldProps) => {
  const [viewPass, setViewPass] = useState(false);

  const {
    register,
    formState: { errors },
  } = useFormContext();

  const errorMessage = errors[name]?.message;
  const errorText = typeof errorMessage === "string" ? errorMessage : "";

  return (
    <div className={`${className} relative mb-4 w-full`}>
      <label
        htmlFor={name}
        className="block pb-1 text-sm font-medium text-gray-700"
      >
        {label}
      </label>
      <div className="relative">
        <input
          {...register(name)}
          id={name}
          type={viewPass ? "text" : type}
          placeholder={placeholder}
          autoComplete={type === "password" ? "current-password" : "off"}
          className="mt-1 block w-full py-2 px-4 border border-gray-300 rounded-[8px] shadow-sm focus:outline-none focus:ring-secondary focus:border-secondary text-sm placeholder:text-sm"
        />
        {type === "password" && (
          <div
            className="absolute cursor-pointer right-4 top-3"
            onClick={() => setViewPass(!viewPass)}
          >
            {viewPass ? <EyeCross /> : <Eye />}
          </div>
        )}
      </div>
      {icon && (
        <div className="absolute top-[53%] right-3 pointer-events-none">
          {icon}
        </div>
      )}
      {errors[name] && <p className="mt-2 text-sm text-red-600">{errorText}</p>}
    </div>
  );
};

export default HookFormInputField;
